export const ActionTypes = {
  GET_POPULAR_SPORTS_REQUEST: '[POPULAR SPORTS] GET POPULAR SPORTS REQUEST',
  GET_POPULAR_SPORTS_SUCCESS: '[POPULAR SPORTS] GET POPULAR SPORTS SUCCESS',
  GET_POPULAR_SPORTS_FAILURE: '[POPULAR SPORTS] GET POPULAR SPORTS FAILURE',
};

export class Actions {
  static getPopularSportsRequest() {
    return {
      type: ActionTypes.GET_POPULAR_SPORTS_REQUEST
    };
  }

  static getPopularSportsSuccess(items) {
    return {
      type: ActionTypes.GET_POPULAR_SPORTS_SUCCESS,
      sportGroups: items
    };
  }

  static getPopularSportsFailure() {
    return {
      type: ActionTypes.GET_POPULAR_SPORTS_FAILURE
    };
  }
}
